// extracted by mini-css-extract-plugin
export default {"AuditLogNestedList":"styles_AuditLogNestedList__9LtcT","nestedChild":"styles_nestedChild__SX5ii","title":"styles_title__UGGrJ"};